import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    Box,
    Card,
    CardContent,
    Container,
    Grid,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    ToggleButton,
    ToggleButtonGroup,
    Typography,
} from '@mui/material';
import GridViewIcon from '@mui/icons-material/GridView';
import ListIcon from '@mui/icons-material/List';
import '../App.css';
import { RECIPE_TYPES } from '../constants/Constants';

const VIEW_MODE_KEY = 'recipeViewMode';

const RecipeType = () => {
    const [viewMode, setViewMode] = useState(localStorage.getItem(VIEW_MODE_KEY) || 'grid');

    const handleViewMode = (_, newMode) => {
        if (!newMode) return;
        setViewMode(newMode);
        localStorage.setItem(VIEW_MODE_KEY, newMode);
    };

    return (
        <Container component="main" sx={{ mt: 5, width: '90%', pb: 12 }}>
            <Box sx={{ mb: 3 }}>
                <Grid container alignItems="center">
                    <Grid item xs />
                    <Grid item>
                        <Typography variant="h5" sx={{ fontWeight: 700, textAlign: 'center' }}>
                            Recipe Types
                        </Typography>
                    </Grid>
                    <Grid item xs sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                            <ToggleButtonGroup value={viewMode} exclusive onChange={handleViewMode} size="small">
                                <ToggleButton value="grid"><GridViewIcon fontSize="small" /></ToggleButton>
                                <ToggleButton value="list"><ListIcon fontSize="small" /></ToggleButton>
                            </ToggleButtonGroup>
                        </Box>
                    </Grid>
                </Grid>
                <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'center', mt: 1 }}>
                    <ToggleButtonGroup value={viewMode} exclusive onChange={handleViewMode} size="small">
                        <ToggleButton value="grid"><GridViewIcon fontSize="small" /></ToggleButton>
                        <ToggleButton value="list"><ListIcon fontSize="small" /></ToggleButton>
                    </ToggleButtonGroup>
                </Box>
            </Box>

            {viewMode === 'grid' ? (
                <Grid container spacing={2}>
                    {RECIPE_TYPES.map((type) => (
                        <Grid item key={type.id} xs={6} sm={4} md={3}>
                            <Link to={`/types/${type.key}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                    <Box sx={{ height: 140, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'grey.100' }}>
                                        <Typography sx={{ fontSize: '4rem', lineHeight: 1 }}>{type.icon}</Typography>
                                    </Box>
                                    <CardContent sx={{ textAlign: 'center', flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                            {type.title}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Link>
                        </Grid>
                    ))}
                </Grid>
            ) : (
                <List disablePadding>
                    {RECIPE_TYPES.map((type) => (
                        <ListItem key={type.id} disablePadding divider>
                            <ListItemButton component={Link} to={`/types/${type.key}`}>
                                <Typography sx={{ mr: 2, fontSize: '1.4rem', lineHeight: 1 }}>{type.icon}</Typography>
                                <ListItemText primary={type.title} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            )}
        </Container>
    );
};

export default RecipeType;
